<template>
  <ag-modal-container
    :title="'Relevé incorrect détecté'"
    width="500px"
    no-content-padding
    toolbar-color="error"
    @close="close"
  >
    <v-form ref="rejectionForm" v-model="mainFormValid" class="pa-6">
      <ag-autocomplete
        v-model="decision.cause"
        outlined
        label="Choix de la cause du défault *"
        :item-list="rejectionCauseList"
        item-text="name"
        item-value="value"
        :rules="[v => !!v || 'Requis']"
      />
      <v-text-field
        v-if="decision.cause !== ''"
        v-model="decision.justification"
        hide-details="auto"
        outlined
        label="Commentaire"
        :rules="[v => (!!v || decision.value !== 2) || 'Requis']"
      />
      <v-radio-group
        v-if="decision.cause !== ''"
        v-model="decision.value"
        label="Choix de l'action à prendre *"
        :rules="[v => !!v || 'Requis']"
      >
        <v-radio
          label="Rebuter la/les pièce(s)"
          :value="1"
        />
        <v-radio
          label="Déroger la/les pièce(s)"
          :value="2"
        />
        <v-radio
          v-if="batchOperation.operation.operationType.alterationAllowed"
          label="Envoyer la/les pièce(s) en retouche"
          :value="3"
        />
        <v-radio
          v-if="!batchOperation.operation.operationType.control && !declarationMode"
          label="Mettre la pièce en quarantaine"
          :value="4"
        />
        <v-radio
          v-else-if="!declarationMode"
          label="Mettre la décision en suspens"
          :value="5"
        />
      </v-radio-group>
    </v-form>
    <template v-slot:footer>
      <v-spacer />
      <v-btn
        :disabled="!mainFormValid"
        color="accent"
        class="ml-5"
        @click="validate"
        v-text="'Valider'"
      />
      <v-spacer />
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import AgAutocomplete from 'src/components/common/AgAutocomplete'

export default {
  name: 'RejectionSelection',
  components: {
    AgModalContainer,
    AgAutocomplete,
  },
  props: {
    batchOperation: {
      type: Object,
      required: true,
    },
    partList: {
      type: Array,
      default: () => [],
    },
    recordList: {
      type: Array,
      default: () => [],
    },
    declarationMode: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    mainFormValid: false,
    decision: {
      cause: '',
      value: null,
    },
    rejectionCauseList: [],
  }),
  computed: {
    ...mapGetters('me', {
      role: 'role',
    }),
    ...mapGetters('batch', {
      batch: 'batch',
    }),
    isValidForm () {
      return this.mainFormValid
    },
  },
  watch: {
    batchOperation: {
      immediate: true,
      async handler () {
        this.rejectionCauseList = await Repositories.rejectionCause.getRejectionListForOperation({
          operationTypeId: this.batchOperation.operation.operationType._id,
          partTypeId: this.batch.partType._id,
        })
      },
    },
    'decision.value': {
      immediate: false,
      async handler () {
        this.mainFormValid = this.$refs.rejectionForm.validate()
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    close () {
      this.$emit('close')
    },
    validate () {
      this.$emit('validation', this.decision)
    },
  },

}
</script>
